import { render, staticRenderFns } from "./ContentSelectionSundayReactionMobile.vue?vue&type=template&id=5988bc79&scoped=true&"
import script from "./ContentSelectionSundayReactionMobile.vue?vue&type=script&lang=js&"
export * from "./ContentSelectionSundayReactionMobile.vue?vue&type=script&lang=js&"
import style0 from "./ContentSelectionSundayReactionMobile.vue?vue&type=style&index=0&id=5988bc79&lang=scss&scoped=true&"
import style1 from "./ContentSelectionSundayReactionMobile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5988bc79",
  null
  
)

export default component.exports